import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, of as observableOf } from 'rxjs';
import { catchError, map, mapTo, startWith, switchMap } from 'rxjs/operators';
import { AbstractTopServiceApiService } from '../../../core/services/abstract/abstract-top-service-api-service';
import * as actions from './actions';

@Injectable()
export class TopServiceEffects {
  private service = inject(AbstractTopServiceApiService);
  private actions$ = inject(Actions);

  getAllEffect$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType<actions.GetAllRequest>(actions.ActionTypes.GET_ALL_REQUEST),
      switchMap(action =>
        this.service.getAll().pipe(
          map(response => (response.isSucceeded ? new actions.GetAllSuccess(response.result) : new actions.Failure(response.errors[0]))),
          catchError(error => observableOf(new actions.Failure(error)))
        )
      )
    )
  );

  upPriorityEffect$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType<actions.UpPriorityRequest>(actions.ActionTypes.UP_PRIORITY_REQUEST),
      switchMap(action =>
        this.service.upPriority(action.entity).pipe(
          map(items => (items.isSucceeded ? new actions.GetAllRequest() : new actions.Failure(items.errors[0]))),
          catchError(error => observableOf(new actions.Failure(error)))
        )
      )
    )
  );

  downPriorityEffect$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType<actions.DownPriorityRequest>(actions.ActionTypes.DOWN_PRIORITY_REQUEST),
      switchMap(action =>
        this.service.downPriority(action.entity).pipe(
          map(items => (items.isSucceeded ? new actions.GetAllRequest() : new actions.Failure(items.errors[0]))),
          catchError(error => observableOf(new actions.Failure(error)))
        )
      )
    )
  );

  saveEffect$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType<actions.SaveRequest>(actions.ActionTypes.SAVE_REQUEST),
      switchMap(action =>
        this.service.save(action.entity).pipe(
          map(response => (response.isSucceeded ? new actions.SaveSuccess(response.result) : new actions.Failure(response.errors[0]))),
          catchError(error => observableOf(new actions.Failure(error)))
        )
      )
    )
  );

  deleteEffect$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType<actions.DeleteRequest>(actions.ActionTypes.DELETE_REQUEST),
      switchMap(action =>
        this.service.delete(action.id).pipe(
          map(response => (response.isSucceeded ? new actions.DeleteSuccess(response.result) : new actions.Failure(response.errors[0]))),
          catchError(error => observableOf(new actions.Failure(error)))
        )
      )
    )
  );

  syncRequestEffect$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType<actions.SyncRequest>(actions.ActionTypes.SYNC_REQUEST),
      switchMap(action =>
        this.service.sync().pipe(
          map(items => (items.isSucceeded ? new actions.GetAllRequest() : new actions.Failure(items.errors[0]))),
          catchError(error => observableOf(new actions.Failure(error)))
        )
      )
    )
  );
}
